/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_O1_CarddetailsInputs */

const en_visa_o1_carddetails = /** @type {(inputs: Visa_O1_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporary classification for individuals with extraordinary ability or achievement and qualifying U.S. work.`)
};

const pt_visa_o1_carddetails = /** @type {(inputs: Visa_O1_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação temporária para pessoas com habilidade ou realização extraordinária e trabalho qualificado nos EUA.`)
};

const es_visa_o1_carddetails = /** @type {(inputs: Visa_O1_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificación temporal para personas con habilidad o logros extraordinarios y trabajo calificado en EE. UU.`)
};

/**
* | output |
* | --- |
* | "Temporary classification for individuals with extraordinary ability or achievement and qualifying U.S. work." |
*
* @param {Visa_O1_CarddetailsInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_o1_carddetails = /** @type {((inputs?: Visa_O1_CarddetailsInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_O1_CarddetailsInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_o1_carddetails(inputs)
	if (locale === "es") return es_visa_o1_carddetails(inputs)
	return en_visa_o1_carddetails(inputs)
});